import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";

const ViewFeedback = ({ sid }) => {
  const { usercourseid } = useParams();
  const [feedbackData, setFeedbackData] = useState([]);
  const [responses, setResponses] = useState({});
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate =useNavigate()
  useEffect(() => {
    const fetchFeedbackQuestions = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/studentfeedback/questions/${sid}`, {
          params: { usercourseid },
        });

        setFeedbackData(response.data);
        const initialResponses = {};
        response.data.forEach((question) => {
          initialResponses[question.idquestion_main] = "";
        });
        setResponses(initialResponses);
      } catch (err) {
        setError("Failed to fetch feedback data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchFeedbackQuestions();
  }, [sid, usercourseid]);

  const handleResponseChange = (id, value) => {
    setResponses((prevResponses) => ({
      ...prevResponses,
      [id]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const answers = Object.entries(responses).map(([idquestion_main, marks]) => ({
        sid,
        idquestion_main,
        marks: parseInt(marks),
      }));

      await api.post(`/api/studentfeedback/updatemarks`, {answers});
      setHasSubmitted(true);
      alert("Form has Been Submitted")
      navigate("/");
    } catch (err) {
      setError("Failed to submit feedback. Please try again.");
    }
  };

  const allQuestionsAnswered = Object.values(responses).every((response) => response !== "");

  if (loading) {
    return <p className="text-gray-600 text-center mt-8">Loading feedback...</p>;
  }

  if (error) {
    return <p className="text-red-500 text-center mt-8">{error}</p>;
  }

  return (
    <div className="container mx-auto mt-8">
      {feedbackData.length > 0 && (
        <>
          <h1 className="text-3xl font-bold text-center mb-4">Feedback</h1>
          <p className="text-sm text-center mb-4 text-gray-600">* Indicates required question</p>

          <div className="space-y-6">
            {feedbackData.map((question, index) => (
              <div
                key={question.idquestion_main}
                className="flex items-center justify-between bg-gray-100 p-4 rounded-lg shadow-md"
              >
                {/* Question Name on the Left */}
                <h2 className="font-semibold text-lg">
                  {index + 1}. {question.qname} <span className="text-red-500">*</span>
                </h2>

                {/* Radio Buttons on the Right */}
                <div className="flex gap-4">
                  {["3", "2", "1", "0"].map((value, optionIndex) => (
                    <label key={optionIndex} className="flex items-center gap-1">
                      <input
                        type="radio"
                        name={`question-${question.idquestion_main}`}
                        value={value}
                        checked={responses[question.idquestion_main] === value}
                        onChange={() => handleResponseChange(question.idquestion_main, value)}
                        disabled={hasSubmitted}
                      />
                      {["Strongly agree", "Agree", "Neutral", "Disagree"][optionIndex]}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-center mt-8">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={handleSubmit}
              disabled={!allQuestionsAnswered || hasSubmitted}
            >
              Submit
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewFeedback;
